import type { TPricing } from "~/components/cards/Pricing.vue";

export const faxPrices: Array<TPricing> = [
    {
      title: "با مرکز تلفن ابری نواتل",
      desc: "مناسب سازمان‌هایی که به دنبال راهکار ارتباطی یکپارچه هستند.",
      img: "/img/new/pricing/fax-with-cloud-pbx.webp",
      boldCard: {
        type: 'popular',
        title: 'پیشنهاد ویژه',
      },
      amounts: [
        {
          title: "به ازای هر ماه/ پرداخت سالانه",
          value: "418",
          unit: "هزار تومان"
        }
      ],
      features: [
        { title: "ارسال و دریافت فکس به تعداد نامحدود", value: true },
        { title: "آرشیو فکس‌ها", value: true },
        { title: "دریافت فکس در ایمیل", value: true },
        { title: "دریافت فکس در اپلیکیشن نواتل", value: true },
        { title: "2 کانال همزمانی رایگان", value: true },
        { title: "فضای ذخیره‌سازی ابری مشترک با مرکز تلفن", value: true }
      ]
    },
    {
      title: "بدون مرکز تلفن ابری نواتل",
      desc: "مناسب سازمان‌هایی که صرفاً به سرویس فکس ابری نیاز دارند.",
      img: "/img/new/pricing/fax-without-cloud-pbx.webp",
      amounts: [
        {
          title: "به ازای هر ماه/ پرداخت سالانه",
          value: "476",
          unit: "هزار تومان"
        }
      ],
      features: [
        { title: "ارسال و دریافت فکس به تعداد نامحدود", value: true },
        { title: "آرشیو فکس‌ها", value: true },
        { title: "دریافت فکس در ایمیل", value: true },
        { title: "دریافت فکس در اپلیکیشن نواتل", value: true },
        { title: "2 کانال همزمانی رایگان", value: true },
        { title: "1 گیگ فضای ذخیره‌سازی ابری", value: true }
      ]
    }
];